// extracted by mini-css-extract-plugin
export var icon = "_9y-3";
export var subtitle = "_9y-2";
export var title = "_9y-1";
export var value = "_9y-0";